import React from "react";
import { Form, Row, Col } from "react-bootstrap";

import "./Forms.css";
import InputError from "../../InputError/InputError";

function TextArea({
  required,
  type,
  formLabel,
  isError,
  size,
  placeholder,
  name,
  value,
  errorMessage = "",
  onChange,
  disabled,
  smallPlaceholder = false,
}) {
  const placeholderClass = smallPlaceholder ? "textarea-small-placeholder" : "";
  return (
    <Form onSubmit={(e) => e.preventDefault()}>
      {type === "inline" ? (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Row>
            <Col sm={4}>
              <Form.Label className="p-1 form-label align-left">
                {formLabel}
                {required && <span className="badge">*</span>}
              </Form.Label>
            </Col>
            <Col sm={6}>
              <textarea
                type="text"
                className={`form-control ${placeholderClass}`}
                placeholder={placeholder}
                size={size}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
              ></textarea>
              <InputError
                isValid={isError}
                message={
                  errorMessage !== "" ? errorMessage : "This field is required"
                }
              />
            </Col>
          </Row>
        </Form.Group>
      ) : (
        <>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="align-left form-label">
              {formLabel}
              {required && <span className="badge">*</span>}
            </Form.Label>
            <textarea
              type="text"
              className={`form-control ${placeholderClass}`}
              placeholder={placeholder}
              size={size}
              name={name}
              value={value}
              onChange={onChange}
              disabled={disabled}
            ></textarea>
            <InputError
              isValid={isError}
              message={
                errorMessage !== "" ? errorMessage : "This field is required"
              }
            />
          </Form.Group>
        </>
      )}
    </Form>
  );
}

export default TextArea;
